import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import resourceSubject from '../reactivity/resource-subject';
import { closest } from '../modules/dom';

Component('tr-todo-labels-begin-edit-trigger', {
  mixins: [eventListenerMixin],
  connected() {
    this.gridCell = closest(this, 'tr-grid-multi-select-cell[key="label_ids"]');
    this.labelField = closest(this, 'tr-todo-label-field');
    [this.gridCell, this.labelField].forEach((parent) => {
      this.listenTo(parent, 'click', () => {
        console.debug('label field clicked');
        resourceSubject('user-guide').next('todo_labels_begin_edit', {});
      });
    });
  },
  disconnected() {
    this.stopListening();
  },
});
